<div class="data-preview" [class.error]="error()">
  @if (heading(); as heading) {
    <div class="heading">
      <div class="heading-group">
        <p class="f-body-l f-medium">{{ heading | translate }}</p>

        <div class="options">
          <ng-content select="[left]"></ng-content>
        </div>
      </div>

      <div class="options">
        <ng-content select="[right]"></ng-content>
      </div>
    </div>
  }

  <ng-content></ng-content>
</div>
